import { PublicKey } from '@solana/web3.js';
import { GpaBuilder } from '../../../utils/GpaBuilder.mjs';

// TODO(thlorenz): copied from candy machine SDK
// SDK should either provide a GPA builder or expose this discriminator
const candyMachineDiscriminator = [51, 173, 177, 113, 25, 241, 109, 189];
const AUTHORITY = candyMachineDiscriminator.length;
const WALLET = AUTHORITY + PublicKey.default.toBytes().byteLength;
class CandyMachineGpaBuilder extends GpaBuilder {
  whereDiscriminator(discrimator) {
    return this.where(0, Buffer.from(discrimator));
  }

  candyMachineAccounts() {
    return this.whereDiscriminator(candyMachineDiscriminator);
  } // wallet same as solTreasury


  candyMachineAccountsForWallet(wallet) {
    return this.candyMachineAccounts().where(WALLET, wallet.toBase58());
  }

  candyMachineAccountsForAuthority(authority) {
    return this.candyMachineAccounts().where(AUTHORITY, authority.toBase58());
  }

}

export { CandyMachineGpaBuilder };
//# sourceMappingURL=CandyMachineGpaBuilder.mjs.map
